module.exports = __webpack_public_path__ + "static/acai3-58a6deb1387fd358eab57775ee58e5bc.png";